<template>
  <div v-if="photos.length" class="photos-widget">
    <div class="photos-widget__wrap container">
      <div class="photos-widget__header">
        <h2 class="photos-widget__title">Фото</h2>
        <AppBtn
          v-if="$route.name !== 'albums'"
          class="photos-widget__btn"
          to="/photos"
          color="fifth"
        >
          Все фото
        </AppBtn>
      </div>

      <div class="photos-widget__content">
        <div ref="photos" class="photos-widget__list swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(photo, index) in photos"
              :key="index"
              @click="showSlide(photo)"
            >
              <img :src="photo.preview.url" :alt="photo.text" />
            </div>
          </div>

          <div class="photos-widget__prev swiper-button-prev">
            <svg-icon size="16" icon-name="arrow-left" />
          </div>
          <div class="photos-widget__next swiper-button-next">
            <svg-icon size="16" icon-name="arrow-right" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { openImage } from "@/components/common/ImageModal";
import service from "@/services/photos";

export default {
  name: "PhotosWidget",

  data: () => ({
    swiper: null,
    photos: []
  }),

  async mounted() {
    await this.loadPhotos();
    if (this.photos.length) {
      this.$nextTick(this.some);
    }
  },

  methods: {
    async loadPhotos() {
      this.loading = true;
      try {
        const { data, success } = await service.getRecentPhotos();
        if (success) {
          this.photos = data;
        }
      } catch (e) {
        console.log("Load photos error:", e);
      }
      this.loading = false;
    },
    async showSlide(item) {
      await openImage({
        src: item.photo ? item.photo.url : item.preview.url,
        title: item.text
      });
    },
    some() {
      const { thresholds, scrollbarWidth } = this.$core.breakpoint;
      this.swiper = new Swiper(this.$refs.photos, {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          470: {
            slidesPerView: 1
          },
          [thresholds.md - scrollbarWidth - 1]: {
            slidesPerView: 2
          },
          [thresholds.lg - scrollbarWidth - 1]: {
            slidesPerView: 3
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.photos-widget {
  padding: 35px 0;
  height: 370px;
  background: url("~@/assets/images/photos/photos-bg.png") 50% 0 no-repeat;
  margin-bottom: 10px;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  &__title {
    font-size: 30px;
    /* font-weight: 900; */
    text-transform: uppercase;
    font-family: fonts(second);
    color: colors(text-2);
    margin-left: 18px;
  }

  &__list {
    padding: 0 40px;

    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 177px;

      img {
        display: block;
        width: 100%;
        box-shadow: 0 0 15px -5px colors(palette-2);
        cursor: pointer;
      }
    }
  }

  &__prev,
  &__next {
    height: 100%;
    width: 30px;
    top: 0;
    margin-top: 0;
    color: colors(text-3);
    background-image: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:after {
      content: none;
    }
  }

  &__prev {
    left: 0;
    background-color: colors(palette-4);
  }

  &__next {
    right: 0;
    background-color: colors(palette-10);
  }

  &__btn {
    margin-left: auto;
    width: 200px;
    text-transform: uppercase;
    font-size: 16px;
  }

  @include breakpoint("xs-only") {
    &__header {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;
    }
    &__title {
      margin-left: 0;
    }
    &__btn {
      margin-left: 0;
      margin-top: 10px;
      width: 100%;
      display: flex;
      height: 45px;
    }
  }
}
</style>
